<template>
    <div class="col-md-12 form-group">
        <ShowAnswer v-if="!showEdit" :text="text" :sort-order="sortOrder"/>
        <EditAnswer
            v-else
            :initial-text="text"
            :initial-sort-order="sortOrder"
            @answer-updated="handleAnswerUpdated"
            @closed="showEdit = false"
        />
        <div class="form-group row" v-if="!showEdit">
            <div class="col-md-12" style="margin-top: 16px">
                <button :disabled="isSurveyActive" @click="removeAnswer" class="btn btn-danger">
                    <i class="fa fa-trash"/>
                    <span>{{ _t('Delete answer') }}</span>
                </button>
                <button :disabled="isSurveyActive" @click="showEdit = true" class="btn btn-warning">
                    <span>{{ _t('Edit') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ShowAnswer from "./ShowAnswer";
import EditAnswer from "./EditAnswer";
import Swal from "sweetalert2";

export default {
    name: "Answer",
    components: {ShowAnswer, EditAnswer},
    props: [
        'text',
        'sortOrder',
        'questionId',
        'surveyId',
        'isSurveyActive',
        'answerId'
    ],
    data() {
        return {
            showEdit: false,
        }
    },
    methods: {
        handleAnswerUpdated(data) {
            axios.put(`/survey/${this.surveyId}/question/${this.questionId}/answer/${this.answerId}`, data)
                .then((res) => {
                    this.$emit('answer-updated')
                    this.showEdit = false;

                    Swal.fire({
                        text: _t("Answer updated successfully!"),
                        icon: "success",
                        duration: '1000'
                    })
                })
                .catch((err) => {
                    console.log(err)
                    Swal.fire({
                        text: err.response.data.message || 'Something went wrong',
                        icon: "error",
                        duration: '1000'
                    })
                });
        },
        removeAnswer() {
            let that = this;
            Swal.fire({
                text: _t('delete_answer_confirmation-form-label'),
                icon: "warning",
                buttonsStyling: false,
                showCancelButton: true,
                cancelButtonText: _t('Cancel'),
                cancelButtonClass: "btn btn-default",
                confirmButtonText: _t('Yes'),
                confirmButtonClass: "btn btn-success",
            })
                .then(function (result) {
                    if (!result.isConfirmed) return;

                    if (result.value) {
                        axios.delete(`/survey/${that.surveyId}/question/${that.questionId}/answer/${that.answerId}`)
                            .then((res) => {
                                that.$emit('answer-removed')
                                Swal.fire({
                                    text: _t("Answer removed successfully!"),
                                    icon: "success",
                                    duration: '1000'
                                })
                            })
                            .catch((err) => {
                                console.log(err)
                                Swal.fire({
                                    text: err.response.data.message || 'Something went wrong',
                                    icon: "error",
                                    duration: '1000'
                                })
                            });
                    }
                });
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/app/components/Answer.vue